import React from "react";
import "./tournament-players-removed-item.scss"
import { GSButton, GSInfoGroup } from "golfstatus_react_components";
import { formatPhoneNumber } from "../../../helpers/Utilities";
import { faCommentAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import { displayPlayerHandicap } from "../../../helpers/Handicaps";

const TournamentPlayersRemovedItem = (props) => {
  const {
    firstName,
    lastName,
    email,
    phone,
    signupMessage,
    messageClicked,
    flag,
    player,
    tournament,
  } = props;

  const playerInfoSectionItems = [{
    type: "primary no-wrap full-width",
    value: `${firstName} ${lastName} ${displayPlayerHandicap(player, tournament)}`,
  }];

  if (email) {
    playerInfoSectionItems.push({
      type: "secondary no-wrap full-width",
      value: `${email ?? ""}`,
    });
  }

  if (phone) {
    playerInfoSectionItems.push({
      type: "secondary no-wrap full-width",
      value: `${formatPhoneNumber(phone) ?? ""}`,
    });
  }

  const playerInfo = {
    fit: "stretch",
    sections: [
      {
        sectionItems: playerInfoSectionItems,
      },
      {
        sectionItems: [
          {
            type: "primary no-wrap full-width",
            value: <GSButton type="secondary pill red" title="Deleted" buttonIcon={faTrash} />,
          }
        ],
      }
    ],
  };

  const actionInfoSectionItems = [];

  if (flag === "pro") {
    actionInfoSectionItems.push({
      type: "primary no-wrap full-width centered",
      value: <GSButton type="secondary pill green" title="Pro" />,
    });
  }

  if (signupMessage) {
    actionInfoSectionItems.push({
      type: "primary no-wrap full-width centered",
      value: (
        <GSButton
          type="secondary"
          buttonIcon={faCommentAlt}
          onClick={(e) => {
            messageClicked?.({ ...props });
            e?.stopPropagation?.();
          }}
        />
      ),
    });
  }

  const actionInfo = {
    fit: "stretch flex-end",
    sections: [{
      sectionItems: actionInfoSectionItems,
    }],
  };

  const getGroups = () => {
    let groups = [{ ...playerInfo }, { ...actionInfo }];

    return groups;
  };

  return (
    <tournament-players-removed-item>
      <GSInfoGroup dataGroups={getGroups()}></GSInfoGroup>
    </tournament-players-removed-item>
  );
};

export default TournamentPlayersRemovedItem;
